module.exports = __webpack_public_path__ + "img/bigulLgLogo.f89f0a34.svg";